import { IRecord, TableColumn } from "../Models/Entities";

//TODO: TypeControl not okay
export const sortRecords = (
  type: TableColumn,
  ascending: boolean,
  records: any
): any => {
  let compareFunction = (a: any, b: any) => {
    const index = type.toString();

    let result = 0;
    if ((a as any)[index] === (b as any)[index]) {
      result = 0;
    } else {
      result = (a as any)[index] < (b as any)[index] ? -1 : 1;
    }

    return ascending ? result : result * -1;
  };

  if (type === TableColumn.CustomerValues) {
    const compareCustomerValues = (a: any, b: any) => {
      const aConverted = +a.customer_value;
      const bConverted = +b.customer_value;
      const aIsNan = Number.isNaN(aConverted);
      const bIsNan = Number.isNaN(bConverted);
      let result = 0;

      if (aIsNan && bIsNan) {
        if (a.customer_value === b.customer_value) {
          result = 0;
        }
        result = a.customer_value < b.customer_value ? -1 : 1;

        return ascending ? result : result * -1;
      }

      if (!aIsNan && bIsNan) {
        result = -1;
      }

      if (aIsNan && !bIsNan) {
        result = 1;
      }

      if (aConverted === bConverted) {
        result = 0;
      }

      result = aConverted < bConverted ? -1 : 1;

      return ascending ? result : result * -1;
    };
    compareFunction = compareCustomerValues;
  }

  records.sort(compareFunction);

  return records;
};
